import React, { useContext, useEffect, useState } from 'react';

import { ThemeContext } from '../../contexts/theme';
import { pointB, pointW } from '../../assets/index';
import './ScrollToTop.css';

/* ------------------------- component ------------------------- */
const ScrollToTop = () => {
  const [{ themeName }] = useContext(ThemeContext);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () =>
      window.pageYOffset > 500 ? setIsVisible(true) : setIsVisible(false);

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  /* ------------------------- render ------------------------- */
  return isVisible ? (
    <div className='scroll-top'>
      <a href='#top'>
        <img alt='pointing up finger' style={{ width: 40 }} src={themeName === 'dark' ? (pointW) : (pointB)} className='scroll-up pointing' />
      </a>
    </div>
  ) : null;
};

export default ScrollToTop;
